<form [formGroup]="filterForm">
  <div class="container mb-3 mt-1 flex grid-gap-15">
    <div class="search-grid style2023 flex-grow-1">
      <div class="input-group">
        <div class="input-group-item">
          <input formControlName="vehicleReg" pInputText placeholder="Search Vehicle Reg." />
        </div>
      </div>
      <div class="input-group">
        <div class="input-group-item">
          <input formControlName="jobNumber" pInputText placeholder="Search Job Num." />
        </div>
      </div>
      <div class="input-group">
        <div class="input-group-item">
          <p-calendar
            formControlName="jobCompletedDate"
            placeholder="Job Completed Date From"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
          ></p-calendar>
        </div>
      </div>
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            [options]="jobStatusOptions"
            formControlName="jobStatusId"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            [options]="additionalChargeTypeOptions"
            formControlName="additionalChargeTypeId"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            [options]="customerOptions"
            formControlName="customerId"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            [options]="additionalChargeStatusOptions"
            formControlName="expenseStatusId"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
      <div>
        <button class="ui-btn ui-button ui-button-primary form-button ml-0">Search</button>
        <button class="ui-btn ui-button ui-button-tertiary form-button" (click)="resetForm()">
          <i class="fa fa-undo"></i>
        </button>
      </div>
    </div>
    <div class="flex-shrink-1 style2023">
      <div class="input-group">
        <div class="input-group-item">
          <p-dropdown
            formControlName="sortBy"
            [style]="{ 'min-width': '220px' }"
            [options]="sortByOptions"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="container">
  <div *ngIf="isLoading" class="center-block"><i class="fa fa-spinner fa-spin"></i> Loading...</div>

  <div *ngIf="!isLoading && (!filteredCharges || filteredCharges.length == 0)" class="center-block">
    No pending additional costs
  </div>

  <div *ngIf="!isLoading">
    <p-table
      [value]="filteredCharges"
      [lazy]="false"
      [paginator]="true"
      [rows]="10"
      [pageLinks]="3"
      [totalRecords]="filteredCharges.length"
      rowHover="false"
      resizableColumns="true"
      [responsive]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Reference<br />Number</th>
          <th>Date Job<br />Completed</th>
          <th>Job Status</th>
          <th>Reg.</th>
          <th>Charge Type</th>
          <th>Customer</th>
          <th>Amount</th>
          <th>Description</th>
          <th>Photo</th>
          <th>Approval<br />Status</th>
          <th>Date Logged</th>
          <th>Approved/<br />Declined By</th>
          <th>Expense<br />Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr
          class="no-stripe"
          (click)="selectCharge(item)"
          [class.selected]="item.id == selectedChargeId"
        >
          <td class="text-center">{{ item.id }}</td>
          <td class="text-center">
            <span *ngIf="item.jobCompletedDate == null" class="job-incomplete-date"
              >Job Incomplete</span
            >
            <span *ngIf="item.jobCompletedDate != null">
              <div>{{ item.jobCompletedDate | datex : "Do MMM 'YY" }}</div>
            </span>
          </td>
          <td class="text-center">
            <div class="job-status-name">{{ jobStatusNames[item.jobStatusId] }}</div>
            <div>
              <a [href]="'/app/jobscreen/' + item.jobId">{{ item.jobNumber }}</a>
            </div>
          </td>
          <td class="text-center">
            <div>{{ item.vehicleReg }}</div>
          </td>
          <td class="text-center">{{ item.additionalChargeTypeName }}</td>
          <td>{{ item.customerName }}</td>
          <td class="charge-amount">
            {{ item.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </td>
          <td>{{ item.description }}</td>
          <td
            (click)="openPhotoPresigned(item.photoUrl)"
            style="cursor: pointer; text-align: center; vertical-align: middle; color: #0082cb"
          >
            <div
              style="display: inline-block; vertical-align: middle"
              *ngIf="item.photoUrl?.length > 0"
            >
              <i class="material-icons">photo_camera</i>
            </div>
          </td>
          <td class="text-center">
            <span class="validation-status validation-status-{{ item.validationStatusId }}">{{
              item.validationStatusName
            }}</span>
          </td>
          <td class="text-center">{{ formatDate(item.dateLogged, "Do MMM 'YY") }}</td>
          <td>{{ item.approvedByUserName }}</td>
          <td style="text-align: center; padding-right: 10px">
            <span class="expense-status expense-status-{{ item.expenseStatusId }}">{{
              item.expenseStatusName
            }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-dialog
  [(visible)]="loadingPopupPhoto || isShownPopupPhoto"
  [modal]="true"
  [positionTop]="10"
  [responsive]="true"
  [style]="{ 'border-radius': '10px' }"
  header="Additional Cost Photograph"
>
  <img *ngIf="isShownPopupPhoto" [src]="popupPhotoUrl" style="width: 100%" />
  <span *ngIf="loadingPopupPhoto"><img src="assets/images/loader.gif" /> Loading...</span>
</p-dialog>
